import { Theme } from "@mui/material";
import { colors } from "../../theme/colors";
import bgImage from "../../assets/bg/bg_main.png";

export const bodyContainer = ({ breakpoints }: Theme) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  minHeight: "95vh",
});

export const subContainer = ({ breakpoints }: Theme) => ({
  marginTop: "90px",
  height: "100%",
  width: { xs: "100%", sm: "500px" },
  borderRadius: { xs: "50px 50px 0 0", sm: "50px" },
  boxShadow: {
    sm: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);",
  },
});

export const bgContainer = ({ breakpoints }: Theme) => ({
  backgroundColor: colors.main,
  borderRadius: "50px 50px 0 0",
  backgroundImage: `url(${bgImage})`,
  backgroundRepeat: "repeat-x",
  height: "160px",
});

export const container = ({ breakpoints }: Theme) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  p: 2,
});

export const button = ({ breakpoints }: Theme) => ({
  color: "white",
  backgroundColor: colors.light_black,
  width: "100%",
  height: "50px",
  fontWeight: "500",
  fontSize: "18px",
  mt: 4,
  "&:hover": {
    backgroundColor: colors.light_black,
  },
});
